import { render, staticRenderFns } from "./allocatedList.vue?vue&type=template&id=1f14a18a&scoped=true&"
import script from "./allocatedList.vue?vue&type=script&lang=js&"
export * from "./allocatedList.vue?vue&type=script&lang=js&"
import style0 from "./allocatedList.vue?vue&type=style&index=0&id=1f14a18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f14a18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f14a18a')) {
      api.createRecord('1f14a18a', component.options)
    } else {
      api.reload('1f14a18a', component.options)
    }
    module.hot.accept("./allocatedList.vue?vue&type=template&id=1f14a18a&scoped=true&", function () {
      api.rerender('1f14a18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/clientInherit/detail/allocatedList.vue"
export default component.exports